import http from '../plugins/http'
import {ADMIN_DASHBOARD} from '@/config/config_api_backend.js'

export const apiGetAllPricingPlan = async () => {
    return (await http.get(ADMIN_DASHBOARD.GET_PRICING_PLAN)).data
}
